import React from 'react';
import debounce from 'debounce';

import { Button, Input, Switch, message, Row,  Col } from 'antd';

import { _postInviteUserToEnterprise } from '../../services';

class InviteUserViaEmail extends React.Component {

	render() {

		const { emailToInvite, sendInvite } = this.state;

		return (
				<Row gutter={0}>
					<Col span={16}>
						<Input
							value={emailToInvite}
							onChange={this.handleOnChangeEmail}
							onPressEnter={this.handleOnClickInvite}
							placeholder={"Invite by email"} />
					</Col>
					<Col span={3}>
						<Button
							onClick={this.handleOnClickInvite}
							type="primary"
						>Invite</Button>
					</Col>
					<Col span={2} align="left">
						<Switch
							checkedChildren="With Email"
							unCheckedChildren="No Email"
							defaultChecked={sendInvite}
							onChange={this.handleOnToggleSendNotif} />
					</Col>
				</Row>
		);
	}

	constructor(props) {
		super(props);

		this.state = {
			emailToInvite: '',
			sendInvite: true
		};

		this.handleCheckValidEmailAndSend = debounce(this.handleCheckValidEmailAndSend, 300);
		this.debounceSetState = debounce(this.debounceSetState, 500);

	}

	debounceSetState = (newState) => {
		this.setState(newState);
	};

	handleCheckValidEmailAndSend = () => {

		let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

		const email = this.state.emailToInvite.trim();

		if (!emailRegex.test(email)) {
			message.destroy();
			return message.error("Please key in a valid email!");
		}

		// post 
		message.loading(`Adding ${email}..`);

		_postInviteUserToEnterprise({
			enterpriseId: this.props.enterpriseId,
			email,
			sendInvite: this.state.sendInvite
		})
			.then(res => {
				message.destroy();
				message.success(`${email} was successfully invited!`);
				this.props.getEnterpriseUsers();
			})
			.catch(err => {
				message.destroy();
				message.error(`Error: ${err.response ? err.response.data.msg : '500'}`);
			});


	};

	handleOnChangeEmail = (e) => {
		this.setState({
			emailToInvite: e.target.value
		});
	};

	handleOnClickInvite = () => {
		// TRIGGER LOADING MESSAGE INVITING
		this.handleCheckValidEmailAndSend();
	};

	handleOnToggleSendNotif = () => {
		this.setState({
			sendInvite: !this.state.sendInvite
		});
	};


}

export default InviteUserViaEmail;


// WEBPACK FOOTER //
// ./src/components/enterprise/user-email-invite.js